export const AFTER_LOGIN_REDIRECT_TIMEOUT = 1000; // ms
export var AuthProvider;
(function (AuthProvider) {
    AuthProvider["google"] = "google";
    AuthProvider["saml"] = "institution/SAML2";
})(AuthProvider || (AuthProvider = {}));
export const LOGIN_REGULAR = 'regular';
export var LoginErrors;
(function (LoginErrors) {
    LoginErrors["INVALID_EMAIL_OR_PASSWORD_SHOW_HINT"] = "INVALID_EMAIL_OR_PASSWORD_SHOW_HINT";
    LoginErrors["INVALID_EMAIL_OR_PASSWORD_SHOW_HINT_SHOW_CAPTCHA"] = "INVALID_EMAIL_OR_PASSWORD_SHOW_HINT_SHOW_CAPTCHA";
})(LoginErrors || (LoginErrors = {}));
